import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxPopupModule
} from 'devextreme-angular';
import { WorkspaceComponent } from './workspace/workspace.component';
import { SummaryLineComponent } from './summary-line/summary-line.component';
import { SummaryLineTableComponent } from './summary-line-table/summary-line-table.component';
import { ChartsModule } from '../charts/charts.module';
import { OptionMonitorModule } from '../option-monitor/option-monitor.module';
import { SharedModule } from '../shared/shared.module';
import { OptionChainComponent } from './option-chain/option-chain.component';
import { FutureOptionChainComponent } from './future-option-chain/future-option-chain.component';
import { WorkspaceService } from './workspace.service';
import { ReactiveFormsModule } from '@angular/forms';
import {UncommonModule} from "../common/common.module";

@NgModule({
  imports: [
    CommonModule,
    DxPopupModule,
    ChartsModule,
    OptionMonitorModule,
    SharedModule,
    DxButtonModule,
    ReactiveFormsModule
  ],
  declarations: [
    WorkspaceComponent,
    SummaryLineComponent,
    SummaryLineTableComponent,
    OptionChainComponent,
    FutureOptionChainComponent
  ],
  entryComponents: [
    OptionChainComponent,
    FutureOptionChainComponent
  ],
  exports: [
    OptionChainComponent,
    FutureOptionChainComponent,
    SummaryLineTableComponent,
  ],
  providers: [
    WorkspaceService
  ]
})
export class WorkspaceModule {
}
